import { render, staticRenderFns } from "./Paquetes.vue?vue&type=template&id=f779350a&"
import script from "./Paquetes.vue?vue&type=script&lang=js&"
export * from "./Paquetes.vue?vue&type=script&lang=js&"
import style0 from "./Paquetes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports